module.exports = __webpack_public_path__ + "img/pesaj-2018.3a95647c.jpg";